// extracted by mini-css-extract-plugin
export var blockedMessage = "_4g-3";
export var blockedOverlay = "_4g-1";
export var fadeIn = "_4g-2";
export var hereLink = "_4g-0";
export var slideUp = "_4g-4";